import NavigableValidation from "./navigableValidation";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import EmbeddedCollectionValidator from "~/models/navigableValidators/embeddedCollectionValidator";
import Grid from "~/models/dashboards/elements/grid";

export default class DashboardElementGridValidation extends NavigableValidation<Grid> {
  validators = [
    new EmbeddedCollectionValidator({
      validatorKey: 'dashboard_elements',
      section: ValidationModalSection.Layout
    }, this.model),
  ];
}